import React, {createContext, useEffect, useContext} from 'react';
import { Branding } from './brandingService';

const defaultBranding: Branding = {
    "logoUrl": "https://prd.clarynext.com/static/media/Logo.656216d68fa9c8bccee0dbc42d54f548.svg",
    "primaryColor": "168 77% 31%",        /* teal-600 #0D9488 */
    "secondaryColor": "168 35% 95%",      /* light teal surface */
    "accentColor": "168 35% 94%",         /* teal hover tint */
    "fontFamily": "Inter, sans-serif",
    "email": "sharon.tzur1@gmail.com"
};

export const BrandingContext = createContext<{
    branding: Branding | null,
    loading: boolean
}>({
    branding: defaultBranding,
    loading: false
});

export const BrandingProvider = ({
                                     children
                                 }: {
    children: React.ReactNode;
}) => {
    return (
        <BrandingContext.Provider value={{branding: defaultBranding, loading: false}}>
            {children}
        </BrandingContext.Provider>
    );
};


export function ApplyBrandingCSSVars() {
    const { branding, loading } = useContext(BrandingContext);

    useEffect(() => {
        if (branding && !loading) {
            document.documentElement.style.setProperty("--primary", branding.primaryColor);
            document.documentElement.style.setProperty("--secondary", branding.secondaryColor);
            document.documentElement.style.setProperty("--accent", branding.accentColor);
        }
        // Optionally, clear to neutral while loading:
        else if (loading) {
            document.documentElement.style.setProperty("--primary", "220 0% 100%"); // Neutral white
            document.documentElement.style.setProperty("--secondary", "220 0% 98%");
            document.documentElement.style.setProperty("--accent", "220 0% 90%");
        }
    }, [branding, loading]);

    return null;
}